import React from "react";
import { MessageCircle } from "lucide-react";
import { FINAL_CTA } from "../mock";

const WhatsAppFloat = () => (
  <a
    href={FINAL_CTA.whatsapp}
    target="_blank"
    rel="noreferrer"
    className="wa-float"
    aria-label="Contact us on WhatsApp"
    data-testid="whatsapp-float"
  >
    <MessageCircle size={26} />
  </a>
);

export default WhatsAppFloat;
